import * as d3 from "d3";
import {sortChildrenWithSpouses} from "./CalculateTree.handlers.js"
import {createNewPerson} from "../handlers/newPerson.js"
export function shiftSubtree(node, dx, dy, tree, visited = new Set()) {
  if (!node || visited.has(node.data.id)) return;
  visited.add(node.data.id);

  node.x += dx;
  node.y += dy;

  const children = node.children || [];
  children.forEach(child => shiftSubtree(child, dx, dy, tree, visited));

  const spouseIds = node.data.rels?.spouses || [];
  spouseIds.forEach(spouseId => {
    const spouseNode = tree.data.find(n => n.data.id === spouseId);
    if (spouseNode) {
      shiftSubtree(spouseNode, dx, dy, tree, visited);

      const spouseChildren = spouseNode.children || [];
      spouseChildren.forEach(child =>
        shiftSubtree(child, dx, dy, tree, visited)
      );
    }
  });
}


function findIndexLoggedInUser(array) {
  for (let i = 0; i < array.length; i++) {
    if (array[i].data.is_authenticated === "Y") {
      return array[i].id;
    }
  }
  return null;
}
function markMultipleSpouses(tree) {
  tree.forEach(node => {
    const spouseIds = node.data?.rels?.spouses || [];
    
    if (spouseIds.length > 1) {
      // Mark current node as having multiple spouses
      node.data.hasMultipleSpouses = true;

      // Mark each spouse as being in a multi-spouse relationship
      spouseIds.forEach(spouseId => {
        const spouseNode = tree.find(n => n.data.id === spouseId);
        if (spouseNode) {
          spouseNode.data.isMultipleSpouse = true;
        }
      });
    }
  });
}

function mergeExistingMemberRels(main, data_stash) {
  if (main.data.is_existing_member && main.data.existing_member_id) {
    const existing = data_stash.find(
      (node) => node.id === main.data.existing_member_id
    );

    if (existing && existing.rels) {
      let hasConflict = false;

      // Check for conflict: any key has valid values in both main and existing
      for (const key of Object.keys(existing.rels)) {
        const existingVal = existing.rels[key];
        const mainVal = main.rels[key];

        const existingHasValue = Array.isArray(existingVal)
          ? existingVal.length > 0
          : existingVal !== "" && existingVal !== null && existingVal !== undefined;

        const mainHasValue = Array.isArray(mainVal)
          ? mainVal.length > 0
          : mainVal !== "" && mainVal !== null && mainVal !== undefined;

        if (existingHasValue && mainHasValue) {
          hasConflict = true;
          break;
        }
      }
      // If no conflicts, merge only empty values
      if (!hasConflict) {
        for (const key of Object.keys(existing.rels)) {
          const existingVal = existing.rels[key];
          const mainVal = main.rels[key];
          if (Array.isArray(existingVal)) {
            if (Array.isArray(mainVal) && mainVal.length === 0) {
              main.rels[key] = [...existingVal];
            }
          } else {
            if (mainVal === "" || mainVal === null || mainVal === undefined) {
              main.rels[key] = existingVal;
            }
          }
        }

      for (const node of data_stash) {
                if (!node.rels) continue;

                for (const key of Object.keys(node.rels)) {
                  const rel = node.rels[key];

                  // If it's an array (siblings, spouses, children)
                  if (Array.isArray(rel)) {
                    const index = rel.indexOf(existing.id);
                    if (index !== -1) {
                      rel[index] = main.id;
                    }
                  }
                  // If it's a single value (father, mother)
                  else if (rel === existing.id) {
                    node.rels[key] = main.id;
                  }
                }
              }
            if (Array.isArray(existing.rels.spouses)) {
          for (const spouseId of existing.rels.spouses) {
            const spouseNode = data_stash.find(node => node.id === spouseId);
            if (spouseNode && spouseNode.rels) {
              const parentIds = [spouseNode.rels.father, spouseNode.rels.mother];

              for (const parentId of parentIds) {
                if (parentId) {
                  const parentNode = data_stash.find(node => node.id === parentId);
                  if (parentNode && Array.isArray(parentNode.rels.children)) {
                    parentNode.rels.children = [];
                  }
                }
              }
            }
          }
        }

              if (Array.isArray(main.rels.spouses)) {
        for (const spouseId of main.rels.spouses) {
          const spouseNode = data_stash.find(node => node.id === spouseId);
          if (!spouseNode || !spouseNode.rels) continue;

          const parentIds = [spouseNode.rels.father, spouseNode.rels.mother];

          for (const parentId of parentIds) {
            if (!parentId) continue;

            const parentNode = data_stash.find(node => node.id === parentId);
            if (parentNode && Array.isArray(parentNode.rels.children)) {
              parentNode.rels.children = [];
            }
          }
        }
      }

      }
    }
  }
}

export default function CalculateTree({data_stash, main_id=null, is_vertical=true, node_separation=250, level_separation=150,contract=false,setBackup,state}) {
  // TODO:
    sortChildrenWithSpouses(data_stash)
    const main_id_in_url = window.location.href.split('/')[4]?window.location.href.split('/')[4]:main_id;
    const functionality=window.location.href.split('/')[3];
    let cookie_main_id;
    let nodesToDrop=[]
    if(functionality=="sharetree"){
       cookie_main_id=localStorage.getItem('main_id')
     if(main_id!=cookie_main_id){
      console.log("not inside logged in user..")
     }
     else{
      main_id = findIndexLoggedInUser(data_stash)
      localStorage.setItem('main_id', main_id);
     }
    }
    else{
      if (main_id && main_id!=main_id_in_url){
        //pass
      }
      else{
        main_id=main_id_in_url
      }
    }
    cookie_main_id=localStorage.getItem('main_id')
    let  to_be_authenticated=functionality=="sharetree"?cookie_main_id:main_id;
    // const cardAuthenticatedGroup = document.querySelector('g.card-authenticated');
    // if(cardAuthenticatedGroup){
    //   to_be_authenticated=cardAuthenticatedGroup.getAttribute('data-id');
    // }
    const main = main_id !== null ? data_stash.find(d => d.id === main_id) : data_stash[0];
    state.siblingNodes=main.rels.siblings
    state.siblingNodes.push(main.id)
      const mergedIds = [];
      for (const relType in main.rels) {
        if (relType !== 'father' && relType !== 'mother' && relType !== 'spouses') continue;
        const relRaw = main.rels[relType];  

        const relArray = Array.isArray(relRaw)
          ? relRaw                          
          : typeof relRaw === "string"
            ? [relRaw]
            : [];

        if (relArray.length === 0) continue;

        for (const relId of relArray) {
          const relative = data_stash.find(d => d.id === relId);
          if (relative?.data?.is_existing_member && relative.data.existing_member_id) {
            if (mergedIds.length === 0) {
              setBackup(structuredClone(data_stash)); // only once
            }
            mergedIds.push(relative.data.existing_member_id); // track for filtering
            mergeExistingMemberRels(relative, data_stash);
          }
        }
      }
      if (main.data.is_existing_member && main.data.existing_member_id) {
        setBackup(structuredClone(data_stash));
        mergedIds.push(main.data.existing_member_id);
        mergeExistingMemberRels(main, data_stash);
      }
  const tree_children = calculateTreePositions(main, 'children', false);
   const  tree_parents = calculateTreePositions(main, 'parents', true);
    levelOutEachSide(tree_parents, tree_children)
    const tree = mergeSides(tree_parents, tree_children)
    setupChildrenAndParents({tree})
    const {main_spouse,main_other_spouses_list}=setupSpouses({tree, node_separation,main,main_id})
    nodePositioning({tree, is_vertical,main_id_in_url,to_be_authenticated})
    main.all_parents=tree_parents
    main.all_children=tree_children
    ShiftAllMembers(tree,main,main_spouse,main_other_spouses_list)
    const MaxMinSpousesMembers=shiftOtherSpouses(tree,main_spouse,main_other_spouses_list)
    const MaxMinMain=getMainMaxMin(tree,main,main_spouse)
    if (MaxMinMain.maxValue < MaxMinSpousesMembers.maxValue) {
      MaxMinMain.maxValue = MaxMinSpousesMembers.maxValue;
    }

    if (MaxMinMain.minValue > MaxMinSpousesMembers.minValue) {
      MaxMinMain.minValue = MaxMinSpousesMembers.minValue;
    }

    setSibling(tree,main,main_spouse,MaxMinMain.maxValue,MaxMinMain.minValue)
    setSibling(tree,main_spouse,main,MaxMinSpousesMembers.maxValue,MaxMinSpousesMembers.minValue)
    if(tree.length==1 && tree[0].data.id==main_id){
      tree[0].x=0
      tree[0]._x=0
    }
    const dim = calculateTreeDim(tree, node_separation, level_separation, is_vertical)
   const seenIds = new Set();
    const removedIds = [];

    const filteredTree = tree.filter(node => {
      const id = node?.data?.id;

      const shouldRemove =
        !id ||
        (main.data.existing_member_id && id === main.data.existing_member_id) ||
        mergedIds.includes(id) ||
        seenIds.has(id);

      if (shouldRemove && id) {
        removedIds.push(id);
        return false;
      }

      if (id) seenIds.add(id);
      return true;
    });



    console.log(filteredTree)
          // Create a quick lookup map once for fast access
    if(contract){
          const findMaxFamilyY = (startNode) => {
            let localMaxY = startNode.y;
          
            const dfs = (currentNode) => {
              if (!currentNode) return;
          
              const { children = [] } = currentNode.data.rels || {};
          
              children.forEach(childId => {
                const childNode = nodeMap.get(childId);
                if (childNode) {
                  localMaxY = Math.max(localMaxY, childNode.y);
                  dfs(childNode); // continue DFS deeper
                }
              });
            };
          
            dfs(startNode);
          
            return localMaxY;
          };
          const nodeMap = new Map(filteredTree.map(node => [node.data.id, node]));

          const findMaxFamilyYAlternate = (startNode, useOriginal = false) => {
            let localMaxY = useOriginal ? startNode.originalY : startNode.y;
          
            const traverse = (childrenIds) => {
              childrenIds.forEach(childId => {
                const childNode = nodeMap.get(childId);
                if (childNode) {
                  const yValue = useOriginal ? childNode.originalY : childNode.y;
                  localMaxY = Math.max(localMaxY, yValue);
          
                  if (childNode.data.rels?.children?.length > 0) {
                    traverse(childNode.data.rels.children);
                  }
                }
              });
            };
          
            if (startNode.data.rels?.children?.length > 0) {
              traverse(startNode.data.rels.children);
            }
          
            return localMaxY;
          };
          let visited = new Set(); // Track already shifted nodes

          // Function to shift a node (and optionally its entire family) by a shift amount
          const shiftNodeAndFamily = (startNode, shiftAmount) => {
            if (!startNode) return;
          
            const dfs = (currentNode) => {
              if (!currentNode || visited.has(currentNode.data.id)) return;
              currentNode.y += shiftAmount;
              visited.add(currentNode.data.id);
          
              const { children = [], spouses = [] } = currentNode.data.rels || {};
          
              // Traverse children
              children.forEach(childId => {
                const childNode = nodeMap.get(childId);
                dfs(childNode);
              });
          
              // Traverse spouses
              spouses.forEach(spouseId => {
                const spouseNode = nodeMap.get(spouseId);
                dfs(spouseNode);
              });
            };
          
            dfs(startNode);
          };
          
        const siblingIds = main.rels.siblings;
        if (siblingIds.length >= 1) {
          // Step 1: Find max Y among all siblings and their families
          const maxSiblingY = siblingIds
            .map(id => nodeMap.get(id))
            .filter(Boolean)
            .reduce((maxY, siblingNode) => {
              const familyMaxY = findMaxFamilyY(siblingNode);
              return Math.max(maxY, familyMaxY);
            }, 0);
            let shiftAmount;
            const main_node=nodeMap.get(main.id)
            if(main_node.y<maxSiblingY) shiftAmount = (maxSiblingY + 150) - main_node.y;
            else shiftAmount = 150;

          // Step 2: Shift main's family (tree_children, main_spouse, other_spouses)
          [...tree_children, main_spouse, ...main_other_spouses_list].forEach(node => {
            //running for all children
            if (node) {
              const targetNode = nodeMap.get(node.data.id);
              if (targetNode) {
                shiftNodeAndFamily(targetNode, shiftAmount);
        
                // Special case: Mark main node
                if (targetNode.data.id === main.id) {
                  targetNode.sibling_y = 0;
                }
              }
            }
          });
          visited.clear();
        }
        
      //  // Function to count all descendants (children, grandchildren, etc.)
        const countFamilySize = (startNode) => {
          let count = 0;

          const find_depth_dfs = (currentNode) => {
            const { children = [] } = currentNode.data.rels || {};
            children.forEach(childId => {
              const childNode = nodeMap.get(childId);
              if (childNode) {
                count++;
                find_depth_dfs(childNode);
              }
            });
          };

          find_depth_dfs(startNode);
          return count;
        };


        //logic to drop children of main members who are having more family members
        const children_ids = main.rels.children;

        if (children_ids.length > 1) {
          const childNodes = children_ids
            .map(id => nodeMap.get(id))
            .filter(Boolean);
        
          // Save original Y positions before any shifting
          childNodes.forEach(node => {
            node.originalY = node.y;
          });
        
          // Step 1: Create array of { node, familySize }
          const childNodesWithSize = childNodes.map(node => ({
            node,
            familySize: countFamilySize(node)
          })).filter(obj => obj.familySize > 1);
          //  Check if at least one node has familySize > 0
          const hasAnyFamily = childNodesWithSize.some(obj => obj.familySize > 0);
        
          if (hasAnyFamily) {
            // Step 2: Sort to find largest families
            childNodesWithSize.sort((a, b) => b.familySize - a.familySize);
            // Step 3: Pick top 50% siblings to drop
            const numberToDrop = Math.ceil(childNodesWithSize.length / 2);
            nodesToDrop = childNodesWithSize.slice(0, numberToDrop).map(obj => obj.node);
            const nodesToDropSet = new Set(nodesToDrop);
        
            let sibling_y = 0;
        
            // Step 4: Loop through original childNodes (not only dropping nodes)
            childNodes.forEach((node, index) => {
              const shouldDrop = nodesToDropSet.has(node);
        
              if (shouldDrop) {
                const prevNode = index > 0 ? childNodes[index - 1] : null;
                const nextNode = index < childNodes.length - 1 ? childNodes[index + 1] : null;
                const prevMaxY = prevNode ? findMaxFamilyYAlternate(prevNode,false) : 0;
                const nextMaxY = nextNode ? findMaxFamilyYAlternate(nextNode, false) : 0;
                const referenceY = Math.max(prevMaxY, nextMaxY);
                const old_y = node.y;
                node.y = referenceY + 150;
                visited.add(node.data.id);
                const shiftAmount = old_y < referenceY ? (referenceY + 150) - old_y : 150;
                const { children = [], spouses = [] } = node.data.rels;
                const relativeIds = [...children, ...spouses];
        
                relativeIds.forEach(relId => {
                  const relativeNode = nodeMap.get(relId);
                  if (relativeNode) {
                    shiftNodeAndFamily(relativeNode, shiftAmount);
                  }
                });    
              }
            });
                let minY = Infinity;

              // First, find the minY among non-dropped nodes and assign sibling_y to dropped ones
              childNodes.forEach(node => {
                if (!nodesToDropSet.has(node)) {
                  minY = Math.min(minY, node.y);
                }
              });
              
              // Now assign sibling_y to dropped nodes and clean up
              childNodes.forEach(node => {
                if (nodesToDropSet.has(node)) {
                  node.sibling_y = minY;
                }
                delete node.originalY;
              });
          }
        }
        
        function getRightmostX(node, visited = new Set()) {
          if (!node || visited.has(node.data.id)) return -Infinity;
          visited.add(node.data.id);
        
          let maxX = node.x;
        
          // Traverse children
          const children = node.children || [];
          children.forEach(child => {
            maxX = Math.max(maxX, getRightmostX(child, visited));
          });
        
          // Traverse spouses
          const spouseIds = node.data.rels?.spouses || [];
          spouseIds.forEach(spouseId => {
            const spouseNode = nodeMap.get(spouseId);
            if (spouseNode) {
              maxX = Math.max(maxX, getRightmostX(spouseNode, visited));
            }
          });
        
          return maxX;
        }
        function shiftSubtreeX(node, shiftAmount, visited = new Set()) {
          if (!node || visited.has(node.data.id)) return;
          visited.add(node.data.id);
        
          node.x += shiftAmount;
        
          // Shift children
          const children = node.children || [];
          children.forEach(child => shiftSubtreeX(child, shiftAmount, visited));
        
          // Shift spouses
          const spouseIds = node.data.rels?.spouses || [];
          spouseIds.forEach(spouseId => {
            const spouseNode = nodeMap.get(spouseId);
            if (spouseNode) {
              shiftSubtreeX(spouseNode, shiftAmount, visited);
            }
          });
        }
        const childNodes = children_ids.map(id => nodeMap.get(id)).filter(Boolean);
        const spacing = 150; // Minimum horizontal spacing
        
        for (let i = 0; i < childNodes.length - 1; i++) {
          const currentNode = childNodes[i];
          const nextNode = childNodes[i + 1];
          if(nodesToDrop.includes(nextNode)){
            const rightmostX = getRightmostX(currentNode);
            const overlap = rightmostX + spacing - nextNode.x;
            if (Math.abs(nextNode.x - currentNode.x)> 250) {
              shiftSubtreeX(nextNode, overlap);
            }
          }
        }     
      }
      else{
        console.log("not contracting.")
      }
      markMultipleSpouses(filteredTree)
      let newOrder = 1;
      filteredTree.forEach(node => {
          const id = node.data.id;

          // Check only siblings
          if (state.siblingNodes.includes(id)) {

              // Update order only if currently 0
              if (node.data.data.order_id === 0) {
                  node.data.data.order_id = newOrder;
                  newOrder++;
              }
          }
      });

  return {data: filteredTree, data_stash, dim,removedIds:removedIds}





  function findShiftValueMainParents(all_parents, main_in_tree,sideMain,sibling) {
    let treeXCoordinates,minAllParents,difference,maxAllParents;
     treeXCoordinates = all_parents?all_parents.map(node => node.x):[];
     let main_in_tree_coordinate=main_in_tree.x
    if(sideMain==1){
      minAllParents = Math.min(...treeXCoordinates);
      difference = main_in_tree_coordinate - minAllParents;
    }
    else{
      maxAllParents = Math.max(...treeXCoordinates);
      difference=main_in_tree_coordinate-maxAllParents
    }
    if (sibling){
      return difference;
    }
    else{
      return Math.abs(difference);
    }
  }

  function findDistanceBetweenFamilies(main_spouse_X,next_spouse_X,side){
    let minmMainSpouse,maxmMainSpouse,minmNextSpouse,maxmNextSpouse,ShiftValue;
    minmMainSpouse=Math.min(...main_spouse_X)
    maxmMainSpouse=Math.max(...main_spouse_X)
    minmNextSpouse=Math.min(...next_spouse_X)
    maxmNextSpouse=Math.max(...next_spouse_X)
    if(side==-1){
      //male 
      ShiftValue=minmMainSpouse-maxmNextSpouse
    }
    else{
      //female
      ShiftValue=maxmMainSpouse-minmNextSpouse
    }
    return ShiftValue
  }

  function getMainMaxMin(tree,main,main_spouse){
    
    let maxValue=-99999999,minValue=999999999
    let main_spouse_X=[]
    tree.forEach((nodeMember,Treeindex)=>{
      if(main.rels.children.includes(nodeMember.data.id)||nodeMember.data.id==main.id||main.rels.spouses.includes(nodeMember.data.id)||(main_spouse && main_spouse.data.rels.spouses.includes(nodeMember.data.id))){
        main_spouse_X.push(nodeMember.x)
        if(nodeMember.x>maxValue)maxValue=nodeMember.x
        if(nodeMember.x<minValue)minValue=nodeMember.x
      }
    })
    
    return {maxValue:maxValue,
      minValue:minValue}
  }




//checking for wife 2
  function shiftOtherSpouses(tree,main_spouse,main_other_spouses_list){
    let maxValue=-99999999,minValue=999999999
    if(main_spouse && main_spouse.data && main_other_spouses_list && main_other_spouses_list.length>0){
              let ShiftValue
              const sideMainSpouse = main_spouse.data.gender === "M" ||main_spouse.data.data.gender && main_spouse.data.data.gender=="M"? -1 : 1;
              //two families needs to be compared, difference between maximum of one with minimum of other

              const total_spouse_length=main_other_spouses_list.length
              main_other_spouses_list.forEach((node,Spousesindex)=>{
                if(!node ||!node.data) return
                // if(Spousesindex==0){
                            //for the 2nd spouse, comparing the x from the main spouse and shifting away from main spouse
                            let main_main_spouse_X=[]
                            let next_to_main_spouse_x=[]
                            let shift_away_from_main_index_list=[]
                            tree.forEach((nodeMember,Treeindex)=>{
                              if(!nodeMember || !nodeMember.data) return
                              if(main_spouse.data.rels.children.includes(nodeMember.data.id)||nodeMember.data.id==main_spouse.data.id){
                                main_main_spouse_X.push(nodeMember.x)
                              }
                              if(node.data.rels.children.includes(nodeMember.data.id)||nodeMember.data.id==node.data.id){

                                next_to_main_spouse_x.push(nodeMember.x)
                                shift_away_from_main_index_list.push(Treeindex)
                              }
                              
                          })
                          ShiftValue=findDistanceBetweenFamilies(main_main_spouse_X,next_to_main_spouse_x,sideMainSpouse)
                          shift_away_from_main_index_list.forEach(eachIndex=>{
                            if(tree[eachIndex].data.id==node.data.id){
                              if(sideMainSpouse==1 && ShiftValue>=0)  {
                               let maxmMainSpouse=Math.max(...main_main_spouse_X)
                               if(maxmMainSpouse==0)
                               {
                                maxmMainSpouse=0.5*node_separation
                               }
                                if(tree[eachIndex].data.rels.children.length==0)
                                  {
                                    tree[eachIndex].x=maxmMainSpouse+(node_separation)
                                  }
                                  else{
                                    tree[eachIndex].x=maxmMainSpouse+node_separation*tree[eachIndex].data.rels.children.length/2
                                  }
                              }  
                                if(sideMainSpouse==-1 && ShiftValue<=0){
                                let minmMainSpouse=Math.min(...main_main_spouse_X)
                                if(minmMainSpouse==0)
                                  {
                                    minmMainSpouse=0.5*node_separation*-1
                                  }
                                if(tree[eachIndex].data.rels.children.length==0)
                                {
                                  tree[eachIndex].x=minmMainSpouse-(node_separation)
                                }
                                else{
                                  tree[eachIndex].x=minmMainSpouse-(node_separation*tree[eachIndex].data.rels.children.length/2)
                                }
                              }
                                tree[eachIndex].sx=tree[eachIndex].x
                            }
                            else{
                                  if(sideMainSpouse==1 && ShiftValue>=0)  {
                                      tree[eachIndex].x+=(Math.abs(ShiftValue)+node_separation)*sideMainSpouse
                                    }  
                                      if(sideMainSpouse==-1 && ShiftValue<=0){
                                      tree[eachIndex].x+=(Math.abs(ShiftValue)+node_separation)*sideMainSpouse
                                  }
                                      tree[eachIndex].sx=tree[eachIndex].x
                            }
                        })

              // }

              if(Spousesindex<=total_spouse_length-2){
                              // let main_spouse_X=[]
                              // let next_spouse_X=[]
                              // let shift_index_list=[]
                              //   tree.forEach((nodeMember,Treeindex)=>{
                              //           if(node.data.rels.children.includes(nodeMember.data.id)||nodeMember.data.id==node.data.id){
                              //             main_spouse_X.push(nodeMember.x)
                              //           }
                              //           if(main_other_spouses_list[Spousesindex+1].data.rels.children.includes(nodeMember.data.id)||nodeMember.data.id==main_other_spouses_list[Spousesindex+1].data.id){
                              //             next_spouse_X.push(nodeMember.x)
                              //             shift_index_list.push(Treeindex)
                              //           }
                                        
                              //   })
                              //   ShiftValue=findDistanceBetweenFamilies(main_spouse_X,next_spouse_X,sideMainSpouse)
                              //       shift_index_list.forEach(eachIndex=>{
                              //           if(tree[eachIndex].data.id==main_other_spouses_list[Spousesindex+1].data.id){
                              //            if(sideMainSpouse==1 && ShiftValue>0)    
                              //               tree[eachIndex].x+=(Math.abs(ShiftValue)+node_separation*tree[eachIndex].data.rels.children.length/2)*sideMainSpouse
                              //            if(sideMainSpouse==-1 && ShiftValue<0)
                              //               tree[eachIndex].x+=(Math.abs(ShiftValue)+node_separation*tree[eachIndex].data.rels.children.length/2)*sideMainSpouse
                              //             tree[eachIndex].sx=tree[eachIndex].x
                              //           }
                              //       })
                      }
                      else{
                        tree.forEach(nodeMember=>{
                          if(!nodeMember ||!nodeMember.data) return
                          if(node.data.rels.children.includes(nodeMember.data.id)||nodeMember.data.id==node.data.id){
                            if(nodeMember.x>maxValue)maxValue=nodeMember.x
                            if(nodeMember.x<minValue)minValue=nodeMember.x
                          }
                        })
                      }
                      main_spouse=node
            })
              // Find the maximum value
          }
      else{
        if(main_spouse){
                tree.forEach(nodeMember=>{
                  if(nodeMember && nodeMember.data && main_spouse && main_spouse.data){
                  if(main_spouse.data.rels.children.includes(nodeMember.data.id)||nodeMember.data.id==main_spouse.data.id){
                    if(nodeMember.x>maxValue)maxValue=nodeMember.x
                    if(nodeMember.x<minValue)minValue=nodeMember.x
                  }
                }
                })
          }
        }
      return {maxValue:maxValue,minValue:minValue}
  }


  function ShiftAllMembers(tree,main){
      //find all the children of main spouse..
      let traversed=[]
      const main_all_parents=main.all_parents
      const main_all_parents_ids=main.all_parents?main.all_parents.map(node => node.data.id):[];
      main.rels.spouses.forEach(each_spouse=>{
                  let spouse=tree.find(d0 => d0.data.id === each_spouse)
                  let spouse_all_parents=spouse && spouse.all_parents?spouse.all_parents:[]
                  let spouse_all_children=spouse && spouse.all_children?spouse.all_children:[]
                  let spouse_all_children_id=spouse && spouse.all_children?spouse.all_children.map(node => node.data.id):[];
                  let spouse_all_parents_id=spouse && spouse.all_parents?spouse.all_parents.map(node => node.data.id):[];
                  let sideMain = main.data.gender === "M" ? -1 : 1;
                  if(main_all_parents && spouse_all_parents && spouse){
                      let mainShift=findShiftValueMainParents(main_all_parents, tree[0],sideMain)
                      let spouseShift=findShiftValueMainParents(spouse_all_parents, spouse,sideMain*-1)
                      tree.forEach(node=> {

                        if(main_all_parents_ids.includes(node.data.id) && node.data.id!=main.id && !traversed.includes(node.data.id)){
                          node.x=node.x+sideMain*(mainShift+node_separation)
                        }
                        if(spouse_all_parents_id.includes(node.data.id) && !traversed.includes(node.data.id)){
                          node.x=node.x+sideMain*-1*(spouseShift+node_separation)
                        }  
                        traversed.push(node.data.id)
                      })
                }
                // if(spouse_all_children_id && spouse){
                //   tree.forEach(node=> {
                //       let spouseChildShift=findShiftValueMainParents(spouse_all_children, spouse,sideMain*-1)
                //       if(spouse_all_children_id.includes(node.data.id)){
                //         console.log("for spouse all children....")
                //         console.log(node)
                //         console.log(sideMain)
                //         console.log(spouseChildShift)
                //         console.log(node_separation)
                //         node.x=node.x+sideMain*-1*(spouseChildShift+node_separation)
                //       } })
                // }


          })
  }


  function calculateTreePositions(datum, rt, is_ancestry) {
    const hierarchyGetter = rt === "children" ? hierarchyGetterChildren : hierarchyGetterParents,
      d3_tree = d3.tree().nodeSize([node_separation, level_separation]).separation(separation),
      root = d3.hierarchy(datum, hierarchyGetter);
    d3_tree(root);
    return root.descendants()

    function separation(a, b) {
      let offset = 1;
      if (!is_ancestry) {
        if (!sameParent(a, b)) offset+=.25
        if (someSpouses(a,b)) offset+=offsetOnPartners(a,b)
        if (sameParent(a, b) && !sameBothParents(a,b)) offset+=.125
      }
      return offset
    }

    // function hasCh(d) {return !!d.children}
    function sameParent(a, b) {return a.parent === b.parent}
    function sameBothParents(a, b) {return (a.data.rels.father === b.data.rels.father) && (a.data.rels.mother === b.data.rels.mother)}
    // function someChildren(a, b) {return hasCh(a) || hasCh(b)}
    function hasSpouses(d) {return d.data.rels.spouses && d.data.rels.spouses.length > 0}
    function someSpouses(a, b) {return hasSpouses(a) || hasSpouses(b)}

    // function hierarchyGetterChildren(d) {
    //   return [...(d.rels.children || [])].map(id => data_stash.find(d => d.id === id))
    // }

    // function hierarchyGetterParents(d) {
    //   return [d.rels.father, d.rels.mother]
    //     .filter(d => d).map(id => data_stash.find(d => d.id === id))
    // }
    function hierarchyGetterParents(d) {
      return [d.rels.father, d.rels.mother]
          .map(id => data_stash.find(member => member.id === id)) // Find member by ID
          .filter(member => member !== undefined); // Filter out undefined members
  }
  
  // function hierarchyGetterChildren(d) {
  //     return d.rels.children
  //         .map(id => data_stash.find(member => member.id === id)) // Find member by ID
  //         .filter(member => member !== undefined); // Filter out undefined members
  // }
  function hierarchyGetterChildren(d) {
  const childIds = new Set(d.rels.children || []);

  // // Include children from each spouse
  // (d.rels.spouses || []).forEach(spouseId => {
  //   const spouse = data_stash.find(m => m.id === spouseId);
  //   if (spouse && Array.isArray(spouse.rels.children)) {
  //     spouse.rels.children.forEach(childId => childIds.add(childId));
  //   }
  // });

  // Map to actual member objects
  return Array.from(childIds)
    .map(id => data_stash.find(member => member.id === id))
    .filter(member => member !== undefined);
}

    function offsetOnPartners(a,b) {
      return (Math.max((a.data.rels.spouses || []).length, (b.data.rels.spouses || []).length))*.5+.5
    }
  }

  function levelOutEachSide(parents, children) {
    const mid_diff = (parents[0].x - children[0].x) / 2
    parents.forEach(d => d.x-=mid_diff)
    children.forEach(d => d.x+=mid_diff)
  }

  function mergeSides(parents, children) {
    parents.forEach(d => {d.is_ancestry = true})
    parents.forEach(d => d.depth === 1 ? d.parent = children[0] : null)

    return [...children, ...parents.slice(1)];
  }
  function nodePositioning({tree, is_vertical,main_id_in_url,to_be_authenticated}) {
    if(tree){
          tree.forEach(d => {
            if(d.data.id==to_be_authenticated){
                d.data.authenticated=true
            }
            else{
              d.data.authenticated=false
            }
            d.y *= (d.is_ancestry ? -1 : 1)
            if (!is_vertical) {
              const d_x = d.x; d.x = d.y; d.y = d_x
            }
          })
      }
  }
  function setSibling(tree,main,main_spouse,spouse_max_X,spouse_min_X){
    // console.log("inside..setSibling")
    //spouse_min_X is a misleading variable. It means main member's minimum value in one case
    let main_father,main_mother,main_id,main_gender,main_spouse_length,main_order_id,main_id_index;
    let main_father_node,main_mother_node,children_node,main_node;
    if(main){
            //getting details of main member whose sibling is to be put
            if(main.rels){
              main_father=main.rels.father;
              main_id=main.id;
              main_mother=main.rels.mother;
              main_spouse_length=main_spouse && main_spouse.data.rels.spouses?main_spouse.data.rels.spouses.length:0

              main_gender=main.data.gender=="M"?-1:1;
              }
            else if(main.data.rels){
              main_father=main.data.rels.father;
              main_id=main.data.id;
              main_mother=main.data.rels.mother;
              main_gender=main.data.data.gender=="M"?-1:1;
              main_spouse_length=main_spouse && main_spouse.rels.spouses?main_spouse.rels.spouses.length:0
            }
            //take father id if father otherwise mother for getting their children who are sibling to the main node in question
            let comparable_id=main_father?main_father:main_mother
            if(comparable_id){
                    tree.forEach((treeNode,treeIndex) => {
                      if(!treeNode || !treeNode.data) return
                          if(treeNode.data.id==comparable_id){
                                  let parent_node=treeNode;
                                //getting children of selected member's father in other words sibling of the main member
                                  main_father_node=treeNode
                                  if(treeNode.data.data.gender=="M" &&treeNode.data.rels.spouses.length>1){
                                      if(main_mother_node){
                                          parent_node=main_mother_node
                                      }
                                      else{
                                         parent_node = tree.find(node => node.data.id === main_mother);
                                      }
                                  }
                                  const parent_tree_children = calculateTreePositions(parent_node.data, 'children', false)
                                  //get only children at the level of main member
                                  children_node = parent_tree_children.filter(node => node.depth === 1);
                                  //since the children are coming sorted from the backend, hence finding the order of the children from index
                                  // children_node.forEach((node,index)=>{
                                  //   node.data.data.order_id=index+1
                                  //   if(node.data.id==main_id){
                                  //     main_order_id=index+1
                                  //   }
                                    
                                  // })
                                  //removing the main member from the list of children, since it will create two main members if not removed
                                  children_node = children_node.filter(node =>node.data.id!=main_id);
                                  if(children_node.length==0) return

                          }
                          else if(treeNode.data.id==main_mother){
                              main_mother_node=treeNode
                          }
                          //this will help in preventing one more iteration of tree to find the main node, storing the index such that could be accessed directly
                          else if(treeNode.data.id==main_id){
                            main_node=treeNode
                            main_id_index=treeIndex

                          }
                          else if (treeNode.data.id==main_father){
                            main_father_node=treeNode
                           }
      
                     });
                        //putting order id in the main node such that it will be utilised to put order number when this node encounters.
                        if(main_id_index)
                          tree[main_id_index].data.data.order_id=main_order_id
                        let child_count=1;
                        if(children_node){
                            let temp_span_sibling_and_spouse=null;
                            let sibling_main_spouse;
                            //children_node signifies siblings
                          children_node.forEach((node,index) => {
                              let main_other_spouses_list=[]
                              let sibling_family_x=[]
                              let sibling_family=[]
                              let sibling_family_x_final=[]
                              let sibling_spouse_id_list=[]
                              let sibling_children_id_list=[]
                              let node_spouse_length=node.data.rels.spouses?node.data.rels.spouses.length:1
                              node.parents=[]
                              if(main_father_node) node.parents.push(main_father_node)
                              if(main_mother_node) node.parents.push(main_mother_node)
                              delete node.children
                              //shift all the siblings to the right or left of main node on the basis of gender
                              if(!temp_span_sibling_and_spouse){
                                      if(spouse_max_X && spouse_min_X){
                                            if(main_gender==1){
                                              node.x=spouse_max_X+node_separation*child_count
                                            }
                                            else
                                            {
                                              node.x=spouse_min_X-node_separation*child_count
                                            }
                                        }
                                        else{
                                          node.x=main_node.x+((node_spouse_length+1)*node_separation*child_count*main_gender)+.8*main_spouse_length*node_separation*main_gender
                                        }
                                }
                                else{
                                  node.x=temp_span_sibling_and_spouse+(node_separation*main_gender)
                                }

                                node.y=node.y-150
                               
                                //adding spouse 


                              let sibling_gender = node.data.data.gender === "M" ? -1 : 1;  // female on right
        
                              //need to create space within same family.

                              node.data.rels.spouses.forEach((sp_id, i) => {
                                sibling_spouse_id_list.push(sp_id)
                                const spouse = {data: data_stash.find(d0 => d0.id === sp_id), added: true}
                                spouse.x = node.x-(node_separation*(i+1))*sibling_gender;
                                sibling_family.push(spouse)
                                spouse.y = node.y
                                spouse.depth = node.depth;
                                spouse.spouse = node;
                                if (!node.spouses) node.spouses = []
                                
                                node.spouses.push(spouse)
                                spouse.sx = i > 0 ? spouse.x : (node.x+spouse.x)/2
                                tree.push(spouse)
                                if(i==0){
                                  sibling_main_spouse=spouse
                                }
                                else{
                                  main_other_spouses_list.push(spouse)
                                }
                                tree.forEach(d0 => {
                                  if (d0 && d0.data &&
                                    ((d0.data.rels.father === node.data.id && d0.data.rels.mother === spouse.data.id) ||
                                    (d0.data.rels.mother === node.data.id && d0.data.rels.father === spouse.data.id))
                                  ) {
                                    d0.psx = spouse.sx;
                                  }
                                });
                                // if (node.parents && node.parents.length === 2) {
                                //   const p1 = node.parents[0],
                                //     p2 = node.parents[1],
                                //     midd = p1.x - (p1.x - p2.x)/2,
                                //     x = (d,sp) => midd + (node_separation/2)*(d.x < sp.x ? 1 : -1)
                          
                                //   p2.x = x(p1, p2); p1.x = x(p2, p1)
                                // }
                               
                              });

                              let node_children;
                              //adding children to member
                              if(node.data.rels.children.length>0){
                                node_children = calculateTreePositions(node.data, 'children', false)
                                node_children.forEach(child => {
                                  child.x += node.x;
                                });
                                node.all_children=node_children.filter((_, index) => index !== 0);
                                node_children=node_children.filter((childNode, index) =>node.data.rels.children.includes(childNode.data.id)||index== 0);

                                let siblingChildrenCount=1
                                node_children.forEach((siblingChildrenNode,siblingChildrenindex)=>{
                                  if(siblingChildrenNode.data.id!=node.data.id){
                                    if(node.data.rels.spouses.length==1||siblingChildrenindex==0){
                                        siblingChildrenNode.x=node.x+node_separation*(siblingChildrenindex-1)*main_gender
                                      }
                                    siblingChildrenCount+=1
                                    siblingChildrenNode.parent=node
                                    sibling_children_id_list.push(siblingChildrenNode.data.id)
                                    sibling_family.push(siblingChildrenNode)
                                  }
                                })
                                node.children=node_children
                              }

                              if(node_children){
                                let node_parents=[]
                                let spouseTree=mergeSides(node_parents, node_children)
                                spouseTree.splice(0,1)
                                mergeTrees(tree,spouseTree,node_separation)
                                // setupChildrenAndParentsForSiblings({tree})
                              }

                              // shiftOtherSpouses(tree,sibling_main_spouse,main_other_spouses_list)

                              node.sx=node.x
                              sibling_family_x.push(node.x)
                              sibling_family.push(node)
                              tree.push(node)
                              tree.forEach(node=>{
                                if(node && node.data){
                                  if(sibling_spouse_id_list.includes(node.data.id)){
                                    sibling_family_x.push(node.x)
                                  }
                                  if(sibling_children_id_list.includes(node.data.id)){
                                    sibling_family_x.push(node.x)
                                  }
                              }
                              })
                              //for maintaining space between two siblings and families
                              // const sibling_family_id_list = sibling_family?sibling_family.map(node => node.data.id):[];

                              //------------------below code commented for testing-------------------------------------------------
                              const sibling_family_id_list = sibling_family? sibling_family.filter(node => node && node.data && node.data.id !== undefined).map(node => node.data.id): [];
                              let sibling_family_to_be_shifted_by
                              if(main_gender==-1){
                      
                                  //main is male
                                  let maxm_sibling_family_x=Math.max(...sibling_family_x)
                                  // sibling_family_to_be_shifted_by=Math.abs(Math.abs(spouse_min_X)-Math.abs(maxm_sibling_family_x))
                                  sibling_family_to_be_shifted_by=spouse_min_X-maxm_sibling_family_x
                                  if(sibling_family_to_be_shifted_by<=0){
                                        tree.forEach(node=>{
                                          if(node && node.data){
                                          if(sibling_family_id_list.includes(node.data.id)){
                                            node.x=node.x-(Math.abs(sibling_family_to_be_shifted_by)+node_separation)
                                            node.sx=node.sx-(Math.abs(sibling_family_to_be_shifted_by)+node_separation)
                                            sibling_family_x_final.push(node.x)
                                          }
                                        }
                                        })
                                    }
                                  if(sibling_family_x_final.length>0){
                                    
                                    temp_span_sibling_and_spouse=Math.max(...sibling_family_x_final)
                                    spouse_min_X=Math.min(...sibling_family_x_final)
                                  }
                                  else{ 
                                    temp_span_sibling_and_spouse=Math.max(...sibling_family_x)
                                    spouse_min_X=Math.min(...sibling_family_x)
                                  }
                                }
                                else{
                                  let min_sibling_family_x=Math.min(...sibling_family_x)
                                  sibling_family_to_be_shifted_by=spouse_max_X-min_sibling_family_x
                                  if(sibling_family_to_be_shifted_by>=0){
                                        tree.forEach(node=>{
                                          if(!node || !node.data) return
                                          if(sibling_family_id_list.includes(node.data.id)){
                                            node.x=node.x+(Math.abs(sibling_family_to_be_shifted_by)+node_separation)
                                            node.sx=node.sx+(Math.abs(sibling_family_to_be_shifted_by)+node_separation)
                                            sibling_family_x_final.push(node.x)

                                          }})
                                        }
                                      if(sibling_family_x_final.length>0){
                                      temp_span_sibling_and_spouse=Math.min(...sibling_family_x_final)
                                      spouse_max_X=Math.max(...sibling_family_x_final)
                                    }
                                    else{
                                      temp_span_sibling_and_spouse=Math.min(...sibling_family_x)
                                      spouse_max_X=Math.max(...sibling_family_x)
                                    }

                                }
                               //------------------above code commented for testing-------------------------------------------------


                              child_count+=1

                            });
                          }
                  }
        }
  }



  function setupChildrenAndParents({tree}) {
    tree.forEach(d0 => {
      delete d0.children
      tree.forEach(d1 => {
        if (d1.parent === d0) {
          if (d1.is_ancestry) {
            if (!d0.parents) d0.parents = []
            d0.parents.push(d1)
          } else {
            if (!d0.children) d0.children = []
            d0.children.push(d1)
          }
        }
      })
    })
  }


  function mergeTrees(mainTree, expandedTree) {
    const nodeMap = new Map();
    mainTree.forEach(node => {
      if(node && node.data)
        nodeMap.set(node.data.id, node);
    });
    var count_node = 0;
    function addNodesFromExpanded(expandedNodes) {
        expandedNodes.forEach(node=> {
            if (!nodeMap.has(node.data.id)) {
                nodeMap.set(node.data.id, node);
                mainTree.push(node);
                count_node += 1;
             } 
          
        });
    }
    addNodesFromExpanded(expandedTree);

    return mainTree;
}


  function setupSpouses({tree, node_separation,main,main_id}) {
    let main_spouse;
    let main_other_spouses_list=[]
    let spouse_counter=0
    for (let i = tree.length; i--;) {
      const d = tree[i]
      if (!d.is_ancestry && d.data.rels.spouses && d.data.rels.spouses.length > 0){
        const side = d.data.data.gender === "M" ? -1 : 1;  // female on right
        
        d.x += d.data.rels.spouses.length/2*node_separation*side;
        // d.x += .5*node_separation*side;
        d.data.rels.spouses.forEach((sp_id, i) => {
          if(main && main.hidden_spouses && !main.hidden_spouses.includes(sp_id)){
          const spouse = {data: data_stash.find(d0 => d0.id === sp_id), added: true}
          if(!spouse || !spouse.data) return
          spouse.x = d.x-(node_separation*(i+1))*side;
          spouse.y = d.y
          

          spouse.depth = d.depth;
          spouse.spouse = d;
          if (!d.spouses) d.spouses = []
      
          d.spouses.push(spouse)
              if(d.data.id==main_id){
                    let spouse_parents,spouse_children;
                    //i==0 for the first spouse of the main id
                    if(i==0){
                                if(spouse.data.rels.father||spouse.data.rels.mother){
                                  spouse_parents = calculateTreePositions(spouse.data, 'parents', true)
                                  spouse.all_parents=spouse_parents.filter((_, index) => index !== 0);
                                  spouse.parents=[];

                                } 
                            
                              if(spouse.data.rels.children.length>0){
                              
                                spouse_children = calculateTreePositions(spouse.data, 'children', false)
                                if(spouse.data.rels.spouses.length>1){
                                  spouse_children=spouse_children.filter((node, index) =>main.rels.children.includes(node.data.id)||index== 0);
                                }
                                spouse.all_children=spouse_children.filter((_, index) => index !== 0);
                                // spouse.children=spouse_children.filter((_, index) => index !== 0);
                                spouse.children = spouse_children.filter(child => 
                                  spouse.data.rels.children.includes(child.data.id)
                                    );
                              
                              }
                              let spouseTree;
                              if(spouse_parents && spouse_children){
                                  levelOutEachSide(spouse_parents, spouse_children)
                                  spouseTree=mergeSides(spouse_parents, spouse_children)
                                  spouseTree.splice(0,1)  
                                  mergeTrees(tree,spouseTree,node_separation)
                                  setupChildrenAndParents({tree})
                                }
                                else if(spouse_parents){
                                  spouse_children=[spouse_parents[0]]
                                  spouseTree=mergeSides(spouse_parents, spouse_children)
                                  spouseTree.splice(0,1)
                                  mergeTrees(tree,spouseTree,node_separation)
                                  setupChildrenAndParents({tree})
                                  //for only parents or for any
                                }
                                else if(spouse_children){
                                  spouse_parents=[]
                                  spouseTree=mergeSides(spouse_parents, spouse_children)
                                  spouseTree.splice(0,1)
                                  mergeTrees(tree,spouseTree,node_separation)
                                  setupChildrenAndParents({tree})
                                }
                                let count_spouse_spouse=0
                                //this block is for other spouses of the spouse of main id
                                spouse.data.rels.spouses.forEach((spouses_spouse_id, i) => {
                                  if(spouses_spouse_id!=d.data.id){
                                    const spouses_spouse = {data: data_stash.find(d0 => d0.id === spouses_spouse_id)}
                                    spouses_spouse.x = d.x+(node_separation*(count_spouse_spouse+1))*side;
                                    spouses_spouse.y = d.y
                                    
                          
                                    spouses_spouse.depth = d.depth;
                                    spouses_spouse.spouse = spouse;
                                    if (!spouse.spouses) spouse.spouses = []
                                    spouse.spouses.push(spouses_spouse)
                                    tree.push(spouses_spouse)
                                    count_spouse_spouse+=1
                                    
                                }
                                })
                                if(count_spouse_spouse>0) delete spouse.spouse
                          }
                          else{
                            
                              spouse_children = calculateTreePositions(spouse.data, 'children', false)
                              spouse.all_children=spouse_children.filter((_, index) => index !== 0);
                              // spouse.children=spouse_children.filter((_, index) => index !== 0);
                              // spouse.children = spouse_children.filter(child => 
                              //   spouse.data.rels.children.includes(child.data.id)
                              //     );
                              spouse.children = spouse_children.filter(
                                child => spouse.data.rels?.children?.includes(child?.data?.id)
                              );

                              spouse.children.forEach(child => {
                                delete child.children;
                              });
                              // tree.push(...spouse.children)
                          }
                    }
                    else{
                           if(spouse.data.rels.children.length>0){
                                let spouse_children = calculateTreePositions(spouse.data, 'children', false)
                                if(spouse.data.rels.spouses.length>1){
                                  spouse_children=spouse_children.filter((node, index) =>main.rels.children.includes(node.data.id)||index== 0);
                                }
                                spouse.all_children=spouse_children.filter((_, index) => index !== 0);
                                //for some crazy reason spouse.children was not working hence pushed in the spouse.data.children and altered handleprogeny to handle the same
                                spouse.data.children = spouse_children.filter(child => 
                                  spouse.data.rels.children.includes(child.data.id)
                                    );
                              }
                    }
                  
          spouse.sx = i > 0 ? spouse.x : (d.x+spouse.x)/2
          if(spouse && spouse.data.rels.spouses.includes(main_id) && spouse.data.id!=main.rels.spouses[0])
            {
              main_other_spouses_list.push(spouse)
            }
          tree.forEach(d0 => {
                  
                  if(d0.data.id==spouse.data.rels.father||d0.data.id==spouse.data.rels.mother){
                    if(!spouse.parents) spouse.parents=[]
                    spouse.parents.push(d0)
                  }
                  if (
                    (d0.data.rels.father === d.data.id && d0.data.rels.mother === spouse.data.id) ||
                    (d0.data.rels.mother === d.data.id && d0.data.rels.father === spouse.data.id)
                  ) {
                    d0.psx = spouse.sx;
                  }
                  
                  // if (d.data.rels.children.includes(d0.data.id)) {
                    
                  //   d0.x -= -125-d0.x;
                  // }
              });
          tree.push(spouse)
          if(spouse.data.id==main.rels.spouses[0]){
            main_spouse=spouse
          }

        }})
      }
      if (d.parents && d.parents.length === 2) {
        const p1 = d.parents[0],
          p2 = d.parents[1],
          midd = p1.x - (p1.x - p2.x)/2,
          x = (d,sp) => midd + (node_separation/2)*(d.x < sp.x ? 1 : -1)

        p2.x = x(p1, p2); p1.x = x(p2, p1)
      }
    }
    return {
      main_spouse: main_spouse,
      main_other_spouses_list: main_other_spouses_list
  }
    // return [main_spouse,main_other_spouses_id_list]
  }

  
  function calculateTreeDim(tree, node_separation, level_separation, is_vertical) {
    if (!is_vertical) [node_separation, level_separation] = [level_separation, node_separation]
    const w_extent = d3.extent(tree, d => d.x),
      h_extent = d3.extent(tree, d => d.y)
    return {
      width: w_extent[1] - w_extent[0]+node_separation, height: h_extent[1] - h_extent[0]+level_separation, x_off: -w_extent[0]+node_separation/2, y_off: -h_extent[0]+level_separation/2
    }
  }

  function createRelsToAdd(data) {
    const to_add_spouses = [];
    for (let i = 0; i < data.length; i++) {
      const d = data[i];

      if (d.rels.children && d.rels.children.length > 0) {
        if (!d.rels.spouses) d.rels.spouses = []
        const is_father = d.data.gender === "M"
        let spouse
        d.rels.children.forEach(d0 => {
          const child = data.find(d1 => d1.id === d0)
          if (child.rels[is_father ? 'father' : 'mother'] !== d.id) return
          if (child.rels[!is_father ? 'father' : 'mother']) return
          if (!spouse) {
            spouse = createToAddSpouse(d)
            d.rels.spouses.push(spouse.id)
          }
          spouse.rels.children.push(child.id)
          child.rels[!is_father ? 'father' : 'mother'] = spouse.id
        })
      }
    }
    to_add_spouses.forEach(d => data.push(d))
    return data

    function createToAddSpouse(d) {
      const spouse = createNewPerson({
        data: {gender: d.data.gender === "M" ? "F" : "M"},
        rels: {spouses: [d.id], children: []}
      });
      spouse.to_add = true;
      to_add_spouses.push(spouse);
      return spouse
    }
  }

}
